export class MassGenerateKITextsParameter {

  constructor(
    public catalogId: string,
    public fullCatalog: boolean,
    public categoryIds: string[],
    public productIds: string[],
    public genVariantTexts: boolean,
    public promptId: string,
    public field: string
  ) {

  }
}
